export const AwsCognitoConfig = {
  APP_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID as string,
  USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
}
